import { observable, action, computed } from 'mobx'
import _ from 'lodash';
import Constants from '../common/Constants';
import { WagerMyBetMap } from '../common/Foundation';
import BetslipAction from '../components/BetslipComponent/BetslipAction';

export default class BetslipStore {

  @observable winRiskOption = Constants.WIN_RISK_OPTION.BASE; // default is BASE

  @observable winRiskOptionReuse = '';

  @observable oddsSelections = []; 

  @observable oddsReuseSelections = []; //reuse Selection

  @observable outrightBetPayLoad = []; // use to save payload for outright bets

  @observable normalBetPayload = {}; // keep payload for normal bets when perform place bet

  @observable parlayBetPayload = {}; // use to save payload for parlay bets when perform place bet.

  @observable teaserBetPayload = {}; // use to save payload for teaser bets when perform place bet.

  @observable normalBetItems = []; // use to render single betslip ui

  @observable parlayBetItems = {}; // use to render parlay betslip ui

  @observable teaserBetItems = {}; // use to render teaser betslip ui

  @observable euroParlayData = {
    selectedRoundRobins: [],
    maxRiskRoundRobin: 0
  }

  @observable normalBetsResponse = [];
  @observable winRiskInfoData = {};
  
  // Reuse Selection Euro 
  @observable parlayBetsResponse = [];

  @observable teaserBetsResponse = [];

  @observable initStakeReuse = 0;

  @observable currentTab = '';

  @observable isTriggerRedirect = false;

  @observable processingQueue = [];

  @observable showPendingToast = false;

  @observable stakePerBet = '';

  @observable enableMaxbet = false;

  @observable initStake = ''

  @observable isDisableInputStake = false;

  @observable isRemoving = false;

  @observable isShowAsiaBetslip = false;
  //Reuse Selection
  @observable isReuseSelection = false;
  @observable isFirstTimeBet = false;
  @observable isChangeWinRiskByReuse = false;
  @observable asiaReuseSingleSelection = {};
  @observable asiaReuseParlaySelections = [];
  @observable asiaOutrightReuseSelection = '';
  @observable asiaTeaserReuseSelections = [];
  @observable ticketId = '';
  //Euro view
  @observable euroReuseSingleOddsId = '';
  @observable euroReuseParlayOddsId = [];

  @observable asiaSingleSelection = {}
  @observable asiaTeaserSelections = []
  @observable asiaOutrightSelection = ''
  @observable asiaParlaySelections = []
  @observable asiaActiveBetslip = ''
  @observable asiaNormalBetItem = ''
  @observable asiaOutrightBetItem = ''
  @observable asiaTeaserBetItem = {}
  @observable asiaParlayBetItem = ''
  @observable isReady = false
  @observable asiaParlayData = {
    stake: '',
    selectedRoundRobins: []
  }
  @observable asiaParlayTicket = {}
  @observable asiaTeaserTicket = []
  @observable asiaPitchers = []
  @observable asiaSingleData = {
    stake: '',
    outRightAcceptBetterOdds: false,
    normalAcceptBetterOdds: false
  }
  @observable asiaTeaserData = {
    stake: '',
    teaserAcceptBetterOdds: false
  }

  @observable isProcessing = false

  @observable startCountdown = false

  @observable resetCountdown = false

  // Use to prevent clear reuse selection when status is pending and user close the betslip
  @observable isSupportedPendingAcceptance = false

  @action setProcessing(isProcessing) {
    this.isProcessing = isProcessing
  }

  @action setSupportedPendingAcceptance(isSupportedPendingAcceptance) {
    this.isSupportedPendingAcceptance = isSupportedPendingAcceptance
  }

  @action updateInitStake(stake) {
    this.initStake = stake
  }

  @action updateBetslipReadyState(isReady) {
    this.isReady = isReady
  }

  /************************************************************
   *    GET AND SET
   ************************************************************/

  @action updateResetCountdown(payload) {
    this.resetCountdown = payload;
  }

  @action updateWinRiskInfoData(winRiskInfoData) {
    this.winRiskInfoData = winRiskInfoData;
  }

  @action updateStartCountdown(payload) {
    this.startCountdown = payload;
  }

  @action updateActiveTab(tabName) {
    this.activeTab = tabName;
  }

  @action changeWinRiskOption(value) {
    this.winRiskOption = value;
  }

  @action changeWinRiskOptionReuse(value) {
    this.winRiskOptionReuse = value;
  }

  @action resetBetsResponse() {
    this.normalBetsResponse = [];
    this.teaserBetsResponse = [];
    this.parlayBetsResponse = [];
  }

  @action updateNormalBetsPayload(payload) {
    this.normalBetPayload = payload;
  }
  
  @action updateParlayBetsResponse(payload) {
    this.parlayBetsResponse = payload;
  }
  @action removeNormalBetReponseItems() {
    this.euroReuseParlayOddsId = []
  }
  @action addReuseParlayOddsIds(selections) {
    let oddsId = [];
    selections.forEach(item => oddsId.push(item.oddsId))
    this.euroReuseParlayOddsId = oddsId;
  }

  @action updateTeaserBetsResponse(payload) {
    this.teaserBetsResponse = payload;
  }


  @action updateParlayBetPayload(payload) {
    this.parlayBetPayload = payload;
  }

  @action updateTeaserBetPayload(payload) {
    this.teaserBetPayload = payload;
  }
  
  @action changeCurrentTab(tabName) {
    this.currentTab = tabName;
  }

  @action addBetItemToProcessingQueue(items) {
    if (Array.isArray(items)) {
      _.forEach(items, (item, index) => {
        this.processingQueue.push(item);
      })
    } else {
      this.processingQueue.push(items);
    }
  }

  @action removeProcessingQueueByWagerId(wagerId) {
    const filter = this.processingQueue.filter(bet => {
      return bet.wagerId !== wagerId;
    })
    this.processingQueue = filter;
  }

  @action triggerShowPendingToast(isShow) {
    this.showPendingToast = isShow;
  }
  @action updateOddsReuseSelectionsFromCache(cacheData) {
    this.oddsReuseSelections = cacheData;
  }
  @action updateOddsReuseSelections(selection) {
    this.oddsReuseSelections = selection;
  }
  @action updateOddsSelectionsFromCache(cacheData) {
    this.oddsSelections = cacheData;
  }
  @action updateInitStakeReuse(stake) {
    this.initStakeReuse = stake;
  }

  @action updateOddsSelections(oddsSelections) {
    this.oddsSelections = oddsSelections;
    this.cacheOddsSelections(this.oddsSelections)
  }

  @action updateTriggerRedirect(isRedirect) {
    this.isTriggerRedirect = isRedirect;
  }

  @action updateStakePerBet(stakePerBet) {
    this.stakePerBet = stakePerBet;
  }

  @action allowMaxBet(enableMaxbet) {
    this.enableMaxbet = enableMaxbet;
  }

  @action disableInputStake(isDisable) {
    this.isDisableInputStake = isDisable
  }

  @action updateRemovingStatus(isRemoving) {
    this.isRemoving = isRemoving;
  }

  @action updateTeaserOddSelectionId(index, value) {
    this.oddsSelections[index].selectionId = value;
  }

  @action updateErrorCodeForTeaserLegItem(index, errorCode) {
    this.teaserBetItems.legs[index].errorCode = errorCode;
  }

  @action updateTeaserPayloadSelectionId(index, value) {
    let legs = JSON.parse(this.teaserBetPayload.legs);
    legs[index].selectionId = value;
    this.teaserBetPayload.legs = JSON.stringify(legs);
  }

  @computed get isRemovingStatus() {
    return this.isRemoving;
  }

  @computed get isParlayBetslipDisplayed() {
    return this.isShowAsiaBetslip && this.asiaActiveBetslip
  }

  @computed get getCurrentTab() {
    return this.currentTab;
  }

  @computed get isResetCountdown() {
    return this.resetCountdown;
  }

  @computed get isStartCountdown() {
    return this.startCountdown;
  }

  @computed get getActiveTab() {
    return this.activeTab;
  }

  @computed get isEnableMaxBet() {
    return this.enableMaxbet;
  }

  @computed get checkDisableInputStake() {
    return this.isDisableInputStake;
  }

  @computed get getNumberSelections() {
    return this.oddsSelections.length;
  }

  @computed get getNumberSingleReuseSelections() {
    return this.oddsReuseSelections.filter((item) =>
      [Constants.WAGER_TYPE.NORMAL, Constants.WAGER_TYPE.OUTRIGHT].includes(
        item.oddsSelectionsType
      )
    ).length;
  }

  @computed get getNumberParlayReuseSelections() {
    const parlaySelection = this.oddsReuseSelections.filter(item => {
      return this.isAllowParlay(item);
    });
    return parlaySelection.length;
  }

  @computed get getNumberTeaserReuseSelections() {
    return this.oddsReuseSelections.filter(item => {
      return item.oddsSelectionsType === Constants.WAGER_TYPE.TEASERS
    }).length;
  }
  
  @computed get getNumberParlaySelections() {
    const parlaySelection = this.oddsSelections.filter(selection => {
      return this.isAllowParlay(selection);
    })
    return parlaySelection.length;
  }

  @computed get getOddsSelections() {
    return this.oddsSelections;
  }

  @computed get getOddsReuseSelections() {
    return this.oddsReuseSelections;
  }

  @computed get getTeaserOddsReuseSelections() {
    return this.oddsReuseSelections.filter(selection => {
      return selection.oddsSelectionsType === Constants.WAGER_TYPE.TEASERS;
    });
  }

  @computed get getTeaserOddsSelections() {
    return this.oddsSelections.filter(selection => {
      return selection.oddsSelectionsType === Constants.WAGER_TYPE.TEASERS;
    })
  }

  @computed get getAsiaTeaserSelections() {
    return this.asiaTeaserSelections;
  }

  @computed get getNumberTeaserSelections() {
    return this.getTeaserOddsSelections.length;
  }

  @computed get getParlayOddsSelections() {
    return this.oddsSelections.filter(selection => {
      return this.isAllowParlay(selection);
    })
  }

  @computed get isStayOnParlayTab() {
    return this.currentTab === Constants.BETSLIP_TAB.PARLAY;
  }

  @computed get isStayOnSingleTab() {
    return this.currentTab === Constants.BETSLIP_TAB.SINGLE;
  }

  @computed get isStayOnTeaserTab() {
    return this.currentTab === Constants.BETSLIP_TAB.TEASERS;
  }

  @computed get isRedirect() {
    return this.isTriggerRedirect;
  }

  @computed get isShowPendingToast() {
    return this.showPendingToast;
  }

  @computed get getProcessingQueue() {
    return this.processingQueue;
  }

  @computed get getParlayBetItems() {
    return this.parlayBetItems;
  }

  @computed get getNumberParlayBetItems() {
    if (this.parlayBetItems.legs) {
      return this.parlayBetItems.legs.length;
    }
    return 0;
  }

  @computed get getParlayBetPayload() {
    return this.parlayBetPayload;
  }

  @computed get getParlayOdds() {
    return this.parlayBetItems.odds;
  }

  @computed get getNormalBetItems() {
    return this.normalBetItems;
  }

  @computed get getNumberNormalBetItems() {
    return this.normalBetItems.length;
  }

  @computed get getNormalBetPayload() {
    return this.normalBetPayload;
  }

  @computed get getWinRiskOption() {
    return this.winRiskOption;
  }

  @computed get getWinRiskOptionReuse() {
    return this.winRiskOptionReuse;
  }

  @computed get getStakePerBet() {
    return this.stakePerBet;
  }

  @computed get getNormalBetsResponse() {
    return this.normalBetsResponse;
  }
  
  @computed get getParlayBetsResponse() {
    return this.parlayBetsResponse;
  }

  @computed get getTeaserBetsResponse() {
    return this.teaserBetsResponse;
  }

  @computed get getNumberTeaserBetsAccepted() {
    return this.teaserBetsResponse.length;
  }
  
  @computed get getNumberBetsAccepted() {
    return this.normalBetsResponse.length;
  }
  
  @computed get getTeaserBetItems() {
    return this.teaserBetItems;
  }

  @computed get getTeaserBetPayload() {
    return this.teaserBetPayload;
  }
  /************************************************************
   *  LOGIC FOR UPDATING DATA
   ************************************************************/

  /**
   * update all odd selection from service to render betslip UI
   * @param {*} betItems 
   */
  @action updateNormalBetItems(betItems) {
    // const unavailableSelections = [];
    let isUnavailableSelections = false;
    const selections = [...this.oddsSelections] // clone selections to modify on it
    // keep old odds if odds changes
    _.forEach(betItems, (item, index) => {
      if (item.status === Constants.ODDS_CHANGE) {
        const filter = selections.filter(selection => {
          return selection.oddsId === item.oddsId;
        })
        if (filter.length > 0) {
          Object.assign(item, { oldOdds: filter[0].odds });
        }
        BetslipAction.updateSelectionIdInPitchersCache(item.selectionId);
      } else if (BetslipAction.isInValidStatus(item.status)) {
        isUnavailableSelections = true;
        _.forEach(selections, (selection, index) => {
          if (selection.oddsId === item.oddsId) {
            // remove unavailable selection when click on parlay tab
            Object.assign(selection, { allowParlay: false })
          }
        })
      }
    })
    if (isUnavailableSelections) {
      this.oddsSelections = selections;
    }
    Object.assign(this.normalBetItems, betItems);
  }

  /**
   * Remove betItem on betslip by oddId
   * @param {*} oddId 
   */
  @action removeNormalBetItems(oddId) {
    const tmp = this.normalBetItems.filter((item) => {
      return item.oddsId !== oddId;
    })
    this.normalBetItems = tmp;
  }
  /**
   * Remove betItem on accepted bet by oddId
   * @param {*} oddId
   */
  @action removeReuseNormalBetReponseItems(oddId) {
    const tmp = this.normalBetsResponse.filter((item) => {
      return item.oddsId !== oddId;
    });
    this.normalBetsResponse = tmp;
    if (!oddId) {
      this.oddsReuseSelections = [];
    }
  }

  /**
   * If we remove betItem then we will also remove it in payload
   * @param {*} oddId 
   */
  @action removeOddSelectionById(oddId) {
    const tmp = this.oddsSelections.filter((item) => {
      return item.oddsId !== oddId;
    })
    this.oddsSelections = tmp;
    //update cache
    this.cacheOddsSelections(this.oddsSelections);
  }

  @action removeOddSelectionBySelectionId(selectionId) {
    const tmp = this.oddsSelections.filter((item) => {
      return item.selectionId !== selectionId;
    })
    const tmpReuse = this.oddsReuseSelections.filter((item) => {
      return item.selectionId !== selectionId;
    })
    this.oddsSelections = tmp;
    this.oddsReuseSelections = tmpReuse;
    //update cache
    this.cacheOddsSelections(this.oddsSelections);
  }

  
  @action removeAllTeaserSelections() {
    const tmp = this.oddsSelections.filter(selection => {
      return selection.oddsSelectionsType !== Constants.WAGER_TYPE.TEASERS;
    })
    this.oddsSelections = tmp;
    //update cache
    this.cacheOddsSelections(this.oddsSelections);
  }

  /**
   * update current response in store with data return after placing bet failed.
   * @param {*} response 
   * @param {*} updatedErrorBetItem 
   */
  @action updateNormalBetsResponse(response, updatedErrorBetItem) {
    //reset response
    this.normalBetsResponse = [];
    // add new bet response
    Object.assign(this.normalBetsResponse, response);
    if (updatedErrorBetItem.length > 0) {
      this.normalBetItems = updatedErrorBetItem;
      // update count number on my bet
      let newOddsSelection = [];
      _.forEach(updatedErrorBetItem, (item, idx) => {
        const index = this.oddsSelections.findIndex(selection => {
          return selection.oddsId === item.oddsId;
        })
        if (index > -1) {
          let newSelectionItem = Object.assign({}, this.oddsSelections[index]);
          newOddsSelection.push(newSelectionItem);
        }
      })
      this.oddsSelections = newOddsSelection;
      //update cache
      this.cacheOddsSelections(this.oddsSelections);

    } else {
      // we will reset payload and normal bet selection if place bet successfully
      this.removeAllBetItems();
    }
  }

  /**
   * save data when user selected odds from odds page.
   * @param {*} selection 
   */
  @action addOddsSelections(selection) {
    const tmp = this.oddsSelections.filter(item => {
      return item.oddsId === selection.oddsId;
    })
    if (tmp.length < 1) {
      this.oddsSelections.push(selection);
      this.cacheOddsSelections(this.oddsSelections);
    }
  }

  @action setParlayBetItems (parlayItems, payload) {
    this.parlayBetItems = parlayItems;
    if (payload){
      this.updateParlayBetPayload(payload);
    }
  }

  @action setTeaserBetItems(teaserBetItems) {
    this.teaserBetItems =  teaserBetItems;
  }

  /**
   * @param {*} payload 
   * @param {*} parlayItems 
   */
  @action updateParlayBetItems(payload, parlayItems) {
    // to show message: Odds has changed from {oldOdds} to {newOdds}
    _.forEach(parlayItems.legs, (leg, index) => {
      if (leg.legStatus === Constants.ODDS_CHANGE) {
        let oldLeg = _.find(this.parlayBetItems.legs, lg => {
          return leg.legId === lg.legId
        });
        if (oldLeg) {
          Object.assign(leg, {
            oldOdds: oldLeg.odds
          });
        } else {
          // get parlay payload to get selection id
          const payloadItem = payload.parlayOddsRequest.parlayOddsSelections.filter(selection => {
            return selection.legId === leg.legId;
          })
          // filter selection base on selection id
          const selection = this.oddsSelections.filter(selection => {
            return selection.selectionId === payloadItem[0].selectionId;
          })
          Object.assign(leg, {
            oldOdds: selection[0].odds
          });
        }
        BetslipAction.updateSelectionIdInPitchersCache(leg.selectionId);
      }
    })
    this.parlayBetItems = parlayItems;
    this.updateParlayBetPayload(payload); // prevent multiple rendering if seperate to 2 function
  }


  @action updateErrorCodeForLeg(legId, errorCode) {
    _.forEach(this.parlayBetItems.legs, (leg, index) => {
      if (leg.legId === legId) {
        Object.assign(leg, {errorCode: errorCode});
        return;
      }
    })
  }

  /** 
   * remove selection in payload and parlay selection
   * @param {*} legId 
   */
  @action removeParlaySelectionById(selectionId, oddId) {
    // delete the selection was removed
    const newSelection = this.oddsSelections.filter((item) => {
      return item.selectionId !== selectionId;
    })
    this.oddsSelections = newSelection;
    // cache selection
    this.cacheOddsSelections(this.oddsSelections);
    // remove on element on single betslip by oddsId
    const newNormalBetItems = this.normalBetItems.filter((item) => {
      return item.oddsId !== oddId;
    })
    this.normalBetItems = newNormalBetItems;
  }


  /**
   * check if selection allow parlay bet or not.
   * @param {*} selection 
   */
  @action isAllowParlay(selection) {
    return selection.parlayRestriction !== Constants.SUPPORT_PARLAY.NOT_ALLOWED &&
      selection.oddsSelectionsType !== Constants.WAGER_TYPE.OUTRIGHT &&
      selection.allowParlay;
  }

  @action removeParlayBetItems() {
    const oddsSelectionsLenghtWithNoTeaser = this.oddsSelections.filter(item => {
      return item.oddsSelectionsType !== Constants.WAGER_TYPE.TEASERS
    }).length;
    if (oddsSelectionsLenghtWithNoTeaser === this.getNumberParlaySelections) {
      this.removeAllBetItems();
    } else {
      // get all selection does not allow parlay bet
      const singleSelections = this.oddsSelections.filter(selection => {
        return !this.isAllowParlay(selection);
      })
      // find element which need remove
      const selectionsNeedRemove = this.oddsSelections.filter(selection => {
        return singleSelections.indexOf(selection) === -1;
      });
      // do remove item on single betslip
      _.forEach(selectionsNeedRemove, item => {
        this.removeNormalBetItems(item.oddsId)
      })

      this.oddsSelections = singleSelections;
      localStorage.removeItem('oddsSelections');
      localStorage.setItem('oddsSelections', JSON.stringify(this.oddsSelections));
      // remove response and payload if there is no parlay selections
      if (this.getNumberParlayBetItems <= 1) {
        this.parlayBetItems = {};
        this.parlayBetPayload = {};
      }
    }
  }

  /**
   * Cache the user's selection
   * @param {*} oddsSelections 
   */
  @action cacheOddsSelections(oddsSelections) {
    localStorage.removeItem('oddsSelections')
    localStorage.setItem('oddsSelections', JSON.stringify(this.oddsSelections));
  }

  /**
   * change status of 'PENDING_ACCEPTANCE' bet in respoonse to new status. 
   * @param {*} response - 'current repsone in store
   * @param {*} myBets - is data returned from service 'my-bets'
   * 
   */
  @action changeStatusOfPendingBet(betItems, myBets) {
    _.forEach(myBets, (item, index) => {
      let pendingItem = betItems.filter(res => {
        return res.wagerId === item[WagerMyBetMap.wagerId];
      })
      if (pendingItem.length > 0) {
        if (item[WagerMyBetMap.status] === Constants.WAGER_STATUS.OPEN) {
          Object.assign(pendingItem[0], {
            status: Constants.ACCEPTED
          })
        } else if (item[WagerMyBetMap.status] === Constants.WAGER_STATUS.CANCELLED) {
          Object.assign(pendingItem[0], {
            status: Constants.PROCESSED_WITH_ERROR,
            errorCode: 'Your bet has been rejected.'
          })
        }
      }
    })
  }
   /**
   * change status of 'PENDING_ACCEPTANCE' bet in respoonse to new status. 
   * @param {*} response - 'current repsone in store
   * @param {*} myBets - is data returned from service 'my-bets'
   * 
   */
    @action changeStatusOfParlayPendingBet(betItems, myBets) {
      _.forEach(myBets, (item, index) => {
        if (item[WagerMyBetMap.wagerMasterId] === betItems.betId ) {
          if (item[WagerMyBetMap.status] === Constants.WAGER_STATUS.OPEN) {
            Object.assign(betItems, {
              status: Constants.ACCEPTED
            })
          } else if (item[WagerMyBetMap.status] === Constants.WAGER_STATUS.CANCELLED) {
            Object.assign(betItems, {
              status: Constants.PROCESSED_WITH_ERROR,
              errorCode: 'Your bet has been rejected.'
            })
          }
        }
      })
    }

  /**
   * Remove all selections
   */
  @action removeAllBetItems() {
    // reset data and payload of normal bet
    this.normalBetItems = [];
    // reset data and payload of parlay bet
    this.parlayBetItems = {};
    this.parlayBetPayload = {};    
    // remove all bet selection except for teaser
    const teaserSelections = this.getTeaserOddsSelections;
    if (teaserSelections.length > 0) {
      this.oddsSelections = teaserSelections;
    } else {
      this.oddsSelections = [];
    }
    // clear cache
    localStorage.removeItem('oddsSelections')
  }

  @action removeAllTeaserBetItems() {
    this.teaserBetItems =  {};
    this.teaserBetPayload = {};
    // only remove teaser selection
    this.removeAllTeaserSelections();
  }

  @action clearOddsSelections() {
    this.oddsSelections = [];
    // clear cache
    localStorage.removeItem('oddsSelections')
  }

  @action clearReuseParlayData() {
    this.euroReuseParlayOddsId = [];
    // clear cache
    this.oddsReuseSelections = []
  }
  
  @action clearReuseTeaserData() {
    this.oddsReuseSelections = this.oddsReuseSelections.filter(item => {
      return item.oddsSelectionsType !== Constants.WAGER_TYPE.TEASERS
    });
  }

  @action displayAsiaBetslip(isShow) {
    this.isShowAsiaBetslip = isShow
  }

  @action setAsiaSingleSelection(selection) {
    this.asiaSingleSelection = selection
  }
  //Reuse Selection
  @action updateIsReuseSelection(isReuseSelection) {
    this.isReuseSelection = isReuseSelection;
  }
  @action updateIsFirstTimeBet(isFirstTimeBet) {
    this.isFirstTimeBet = isFirstTimeBet;
  }
  @action updateIsChangeWinRiskByReuse(isChangeWinRiskByReuse) {
    this.isChangeWinRiskByReuse = isChangeWinRiskByReuse;
  }
  @action setAsiaReuseSingleSelection(selection) {
    this.asiaReuseSingleSelection = selection
  }

  @action setAsiaReuseOutrightSelection(selection) {
    this.asiaOutrightReuseSelection = selection
  }

  @action setAsiaTeaserReuseSelections(selections) {
    this.asiaTeaserReuseSelections = selections
  }

  @action setAsiaReuseParlaySelections(selections) {
    this.asiaReuseParlaySelections = selections
  }
  // Euro Reuse selection
  @action updateEuroReuseSingleOddsId(euroReuseSingleOddsId) {
    this.euroReuseSingleOddsId = euroReuseSingleOddsId;
  }

  @action updateEuroReuseSingleOddsChane(oddsId, odds) {
    let tmp = this.oddsReuseSelections;
    tmp.filter(item => {
      if (item.oddsId === oddsId && item.odds !== odds) {
        item.odds = odds;
      }
    });
    this.oddsReuseSelections = tmp;
  }

  @action setOddsReuseSelections(oddsReuseSelections) {
    this.oddsReuseSelections = oddsReuseSelections;
  }
  
  @action updateTicketId(ticketId) {
    this.ticketId = ticketId
  }

  @action addOddsReuseSelections(selection) {
    const tmp = this.oddsReuseSelections.filter(item => {
      return item.oddsId === selection.oddsId;
    })
    if (tmp.length < 1) {
      this.oddsReuseSelections.push(selection);
    }
  }

  @action setAsiaOutrightSelection(selection) {
    this.asiaOutrightSelection = selection
  }
  
  @action setAsiaTeaserSelections(selections) {
   this.asiaTeaserSelections = selections
  }

  @action updateAsiaActiveBetslip(activeBetslip) {
    this.asiaActiveBetslip = activeBetslip
  }

  @action updateAsiaNormalBetItem(item) {
    this.asiaNormalBetItem = item
  }

  @action updateAsiaOutrightBetItem(item) {
    this.asiaOutrightBetItem = item
  }

  @action updateAsiaTeaserBetItem(item) {
   this.asiaTeaserBetItem = item
 }

  @action setAsiaParlaySelections(selections) {
    this.asiaParlaySelections = selections
  }

  @action addAsiaParlaySelection(selection) {
    if (!this.asiaParlaySelections) {
      this.asiaParlaySelections = []
    }
    this.asiaParlaySelections.push(selection)
  }

  @action addAsiaTeaserSelections(selection) {
    if (!this.asiaTeaserSelections) {
      this.asiaTeaserSelections = []
    }
    this.asiaTeaserSelections.push(selection)
  }

  @action updateAsiaParlayBetItem(item) {
    this.asiaParlayBetItem = item
  }

  @action setAsiaParlayData(data) {
    this.asiaParlayData = data
  }

  @action setAsiaTeaserData(data) {
    this.asiaTeaserData = data
  }

  @action updateAsiaParlayData(key, value) {
    if (value !== null && value !== '' && typeof value !== 'object' && value === this.asiaParlayData[key]) {
      return;
    }

    this.asiaParlayData[key] = value;
  }

  @action updateEuroParlayData(key, value) {
    if (value !== null && value !== '' && typeof value !== 'object' && value === this.euroParlayData[key]) {
      return;
    }

    this.euroParlayData[key] = value;
  }

  @action updateAsiaParlayTicket(parlayTicket) {
    this.asiaParlayTicket = parlayTicket
  }

  @action updateAsiaTeaserTicket(teaserTicket) {
    this.asiaTeaserTicket = teaserTicket
  }

  @action updateAsiaPitchers(pitchers) {
    this.asiaPitchers = pitchers
  }

  @action updateAsiaSingleData(key, value) {
    if (value !== null && value !== '' && typeof value !== 'object' && value === this.asiaSingleData[key]) {
      return;
    }

    this.asiaSingleData[key] = value;
  }

  @action updateAsiaTeaserData(key, value) {
    if (value !== null && value !== '' && typeof value !== 'object' && value === this.asiaTeaserData[key]) {
      return;
    }

    this.asiaTeaserData[key] = value;
  }
  @action updateSelectionOdds(data, index) {
    this.asiaParlaySelections[index].odds = data
  }

  @action updateEuroSelectionOdds(data, index) {
    if (_.get(this.parlayBetItems, ['legs', index])) {
      this.parlayBetItems.legs[index].oldOdds = data;
    }
    this.normalBetItems[index].oldOdds = data;
  }
}


// WEBPACK FOOTER //
// ./src/app/stores/BetslipStore.js